import { basePath } from 'settings/firebaseConfig';

export const DB_CONSULTANCIES_REQUESTS = `${basePath}consultancies_requests`;
export const DB_CONSULTANCIES = `${basePath}consultancies`;
export const DB_USERS = `${basePath}users`;
export const DB_NOTIFICATIONS = `${basePath}notifications`;
export const DB_TICKETS = `${basePath}tickets`;
export const DB_USERS_PRIME = `${basePath}users_prime`;
